// extracted by mini-css-extract-plugin
export default {"webflowStyleInputContainer":"TextInput_webflowStyleInputContainer__iKcpT","webflowStyleInput":"TextInput_webflowStyleInput__uOJft","logoContainer":"TextInput_logoContainer__IBeDD"};